export default "__VITE_ASSET__22570d44__"